import { render, staticRenderFns } from "./beneficiary-created.vue?vue&type=template&id=56cd6e5e&"
import script from "./beneficiary-created.vue?vue&type=script&lang=js&"
export * from "./beneficiary-created.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports